import script from "./PublisherDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PublisherDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./PublisherDetailsModal.vue?vue&type=style&index=0&id=44f5e5d4&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f5e5d4"]])

export default __exports__